var React = require('react');

function Eindustry (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"eind","d":"M4.3,1C2.5,1,1,2.7,1,4.6v15.8c0,0.2,0.1,0.4,0.3,0.4c0,0,0,0,0.1,0c0.1,0,0.3-0.1,0.4-0.2     l3.2-4.4h7.8c1.9,0,3.3-1.3,3.3-3.3V4.6C16,2.8,14.7,1,12.7,1H4.3z M4.3,1.9h8.4c1.4,0,2.4,1.4,2.4,2.7V13c0,1.4-1,2.3-2.4,2.3h-8     c-0.1,0-0.2,0.1-0.3,0.2l-2.5,3.4V4.6C1.9,3.2,3,1.9,4.3,1.9z","key":0}),React.createElement("path",{"className":"eind","d":"M1.3,21.3H1.2l-0.1-0.1c-0.3-0.1-0.6-0.5-0.6-0.9V4.6c0-2.2,1.7-4.1,3.8-4.1h8.4c2.3,0,3.8,2.1,3.8,4.1V13     c0,2.1-1.6,3.8-3.8,3.8H5.2l-3.1,4.2C1.9,21.2,1.6,21.3,1.3,21.3z M4.3,2.4c-1,0-1.8,1-1.8,2.2v12.8L4,15.2     c0.1-0.1,0.3-0.4,0.7-0.4h8c1.1,0,1.9-0.8,1.9-1.8V4.6c0-1-0.7-2.2-1.9-2.2H4.3z","key":1})]);
}

Eindustry.defaultProps = {"fill":"#1b7bdd","width":"20px","height":"20px","viewBox":"0 0 17 22","id":"eindustry"};

module.exports = Eindustry;

Eindustry.default = Eindustry;
